import {useContext} from "react";
import useGetCurrentsTools from "./useGetCurrentsTools.js";
import useGetApiData from "./useGetApiData.js";
import { store } from "../store.js";

const useGetValueFromArray = () => {
  const globalState = useContext(store);
  const getApiData = useGetApiData();
  const globalStateFormData = globalState.state.formData

  const getFormPath = (data, checkedsPathId, path) => {
    
    if (data.globalId == checkedsPathId[0]) {
      let name = data["properties"]["name"].value
      path.name = `${path.name}${(path.name == "" ? name.toString() : "." + name.toString())}`
      path.value = data["properties"]["text"].value
      checkedsPathId.shift();
    } else {
      
      let fieldName = checkedsPathId[0].split("_")[1]
      
      if (fieldName) {
        path.name = `${path.name}.${fieldName}`
        path.value = path.value[fieldName]
        checkedsPathId.shift();
      }
      if (data.type != "Rows" && data.type != "Row") return
    }
    
    if (data.metaData) {
       data.metaData.map(child => { checkedsPathId.length > 0 && getFormPath(child, checkedsPathId, path)
       })
    }
    else checkedsPathId.length > 0 && getFormPath(data, checkedsPathId, path)
    
  }

  const getApiPath = (apiSchema, checkedsPathId, path) => {
    
    if (apiSchema.id == checkedsPathId[0]) {
      path.name = `${path.name}${(path.name == "" ? apiSchema.item.toString() : "." + apiSchema.item.toString())}`
      checkedsPathId.shift();
    }
    
    apiSchema.childs.map(child => checkedsPathId.length > 0 && getApiPath(child, checkedsPathId, path))
  }

  /*
  const getFormValue = (data, id) => {
    var currentTools = []
    
    getCurrentsTools(data, currentTools, [id])
    if (!currentTools[0])
      return id.toString().split("_")[1]
      //return parseInt(id.toString().slice(-1)[0]) == 1 ? "key" : "value"

    return currentTools[0]["properties"]["name"].value
   
    
  }*/

  const getValueFromFormData = (globalId, checkedsPathId, currentFormData = globalStateFormData) => {
    
    //const n = currentFormData.metaData.length;
    var path = {name:""}
    //var i = 0
    //while (i < n) {
      //if (currentFormData.metaData[i].globalId == globalId){
        //getFormPath(currentFormData.metaData[i], checkedsPathId, path)
        getFormPath(currentFormData.metaData[0], checkedsPathId, path)
        
        return path
      //}
      //i = i + 1
    //}
  
    //return "$Not Found$"
  }

  /*
  const getValueFromFormData = (checkedsPathId) => {
   
    var value = getFormValue(globalStateFormData, checkedsPathId[0])
    checkedsPathId.slice(1, checkedsPathId.length).filter(id => {
      value = value + "." + piDFormValue(globalStateFormData,  id)
    })
    return value
  }*/

  const getValueFromArray = (pathId, updatedFormData = globalStateFormData, parents= [], extractData = false , multiplePath = undefined   ) => {
    
    if (multiplePath && multiplePath.length > 0 ) {
     
      var paths = undefined
      multiplePath.forEach(path => {
        var path = getSingleValueFromArray (path, updatedFormData , parents, extractData)
        paths = paths ? {...path, name:paths.name + " , " + path.name} : path
        
      })
      
      return paths
    }
    else
      return getSingleValueFromArray (pathId, updatedFormData , parents, extractData)
    
  }

  const getSingleValueFromArray = (pathId, updatedFormData = globalStateFormData, parents= [], extractData = false ) => {
    if(!parents) parents = []
    const globalId = parents[0] || pathId[0]
    
    const checkedsPathId = [...parents.slice(0, parents.length - 1), ...pathId]  
    const currentApiSchema = globalStateFormData.apiSchemas ? globalStateFormData.apiSchemas.filter(api => api.globalId == globalId) : []
    const currentProfilAndProcess = [...globalState.state.step.decisions,...globalState.state.step.profils, ...globalState.state.variables.users, ...globalState.state.variables.times].filter(profil => profil.id == globalId)
    var path = undefined

    if (currentApiSchema[0])
      path = getValueFromApi(globalId, checkedsPathId, currentApiSchema[0], extractData)
    else if (currentProfilAndProcess[0])
      path = getValueFromProfilAndProcess(checkedsPathId, currentProfilAndProcess[0])
    else if (updatedFormData.metaData[0].globalId == globalId)
      path = getValueFromFormData(globalId, checkedsPathId, updatedFormData)

    if (parents[0]) {
      const pathNames = path.name.split(".")
      path.name = pathNames.slice(parents.length, pathNames.length).join(".")
    }
    

    return path
  }

  const getValueFromProfilAndProcess = (checkedsPathId, currentProfil) => {
    
    
    var path = {name:currentProfil.item}
    var found = false 
    const n = currentProfil.childs.length
    var i = 0
    while (!found && i < n){
      if (currentProfil.childs[i].id == checkedsPathId[1]) {
        path.name = path.name + "." + currentProfil.childs[i].item
        found = true
      }
      i = i + 1
    };
  
    return path
  }

  const getValueFromApi = (globalId, checkedsPathId, currentApiSchema, extractData) => {
    
    //const n = currentApiSchema.length;
    var path = {name:""}
    //var i = 0
    //while (i < n) {
      //if (globalStateFormData.apiSchemas[i].globalId == globalId){
        //getApiPath(globalStateFormData.apiSchemas[i], checkedsPathId, path)
        getApiPath(currentApiSchema, checkedsPathId, path)
        if (extractData) {
          let pathNames =  path.name.split(".")
          pathNames = pathNames.slice(1, pathNames.length) 
          const apiData = globalStateFormData.apiData && globalStateFormData.apiData.filter(item => item.globalId == globalId)[0]
          if(apiData)
          path.value = getApiData(pathNames, apiData.data)
        }
        return path
      //}
     // i = i + 1
    //}
  
    return "$Not Found$"
  }
  /*
  const getApiData = (globalId, pathName) => {
    
    let apiData = globalStateFormData.apiData && globalStateFormData.apiData.filter(item => item.globalId == globalId)[0]
   
    if(apiData) {
      let pathNames =  pathName.split(".")
      pathNames = pathNames.slice(1, pathNames.length)      
      return getValue(apiData.data, pathNames) 
    } else {
      return "$Not Found$"
    }
  }

  const getValue = (data, pathNames) => {
    
    if (!data || pathNames.length == 0 || typeof data != "object" ||  Array.isArray(data)) 
      return !data ? "" : data
    
    
    return getValue(data[pathNames[0]], pathNames.slice(1, pathNames.length))
  }
  */

  return getValueFromArray;
};

export default useGetValueFromArray;
